import React from 'react'
import { Box, Chip, CircularProgress, Tooltip } from '@mui/material'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import { MessageSegment } from '../../../hooks/chatSegments'

type ToolSegment = Extract<MessageSegment, { type: 'tool' }>

const label = (toolName: string): string =>
  toolName
    .replace(/_/g, ' ')
    .replace(/([A-Z])/g, ' $1')
    .toLowerCase()
    .trim()

/** Inline pill for a tool call: spinner while running, ✓/✗ + summary when done. */
const CopilotToolChip: React.FC<{ segment: ToolSegment }> = ({ segment }) => {
  const running = segment.status !== 'done'
  const chip = (
    <Chip
      size="small"
      variant="outlined"
      icon={
        running ? (
          <CircularProgress size={12} sx={{ ml: 0.5 }} />
        ) : segment.success === false ? (
          <ErrorOutlineIcon sx={{ fontSize: 14 }} color="error" />
        ) : (
          <CheckCircleOutlineIcon sx={{ fontSize: 14 }} color="success" />
        )
      }
      label={label(segment.toolName)}
      sx={{
        height: 22,
        fontSize: '0.7rem',
        color: 'text.secondary',
        borderColor: 'background.custom4',
        my: 0.5,
      }}
    />
  )
  return <Box>{segment.summary ? <Tooltip title={segment.summary}>{chip}</Tooltip> : chip}</Box>
}

export default CopilotToolChip
